import React from 'react'
import { CHARGE_CDN } from '../../../../utils/constants'
import './index.less'

interface EmptyPropsRule {
    text?: string
    showShareBtn?: boolean
    onShare?: () => void
}

const Empty = (props: EmptyPropsRule) => {
    const { text, showShareBtn, onShare = () => {} } = props
    return <div className='empty-container'>
        <img src={`${CHARGE_CDN}/sharing/empty.png`} alt="" className='empty-img' />
        {text && <div className='empty-text'>{text}</div>}
        {showShareBtn && <div className='empty-share-btn' onClick={onShare}>去分享</div>}
    </div>
}

export default Empty